export default {
  id: null,
  cooperativa: null,
  agenciaPA: null,
  emailInterno: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/contactinternalmodel.js